import React from 'react';

function Home() {
    return (
        <div className="container text-center">
            <h1>Home</h1>
        </div>
    )
}

export default Home;
